import { PROGRAM_STATUS_ENUMS } from '../components/Onboarding/types';
import { US_STATE_ENUM_VALS } from '../constants/us-states';

export type MarketplaceUserBodyType = {
  email: string;
  first_name: string;
  last_name: string;
};

export enum MARKETPLACE_PROGRAM_TYPES {
  center = 'center',
  exempt = 'exempt',
  fcc = 'fcc',
  forest = 'forest',
  micro = 'micro',
  ministry = 'ministry',
  nanny = 'nanny',
  other = 'other',
}
export type MarketplaceSchoolBodyType = {
  address1: string;
  address2: string | null;
  city: string;
  email: string;
  latitude: string | null;
  licenseCapacity: number;
  longitude: string | null;
  name: string;
  networkCode: string | null;
  programStatus: PROGRAM_STATUS_ENUMS | null;
  programType: MARKETPLACE_PROGRAM_TYPES;
  newSupply: boolean;
  state: US_STATE_ENUM_VALS;
  zipcode: string;
  timezone: string | null;
  phone?: string;
  licenseNumber?: string | null;
};

export interface MarketplaceUserApiProps {
  token: string;
  payload: MarketplaceUserBodyType;
}

export interface MarketplaceSchoolApiProps {
  token: string;
  payload: MarketplaceSchoolBodyType;
}

export enum MARKETPLACE_ENDPOINTS {
  user = 'firebase-api/bootstrap-user/',
  school = 'firebase-api/bootstrap-school/',
}

export enum WS_AUTH_ENDPOINTS {
  getInvitation = 'endpoints-getPendingUserInvite',
}

export interface SsoFetchPayload {
  email: string;
}

export interface FetchBase {
  token?: string;
  endpoint: MARKETPLACE_ENDPOINTS | WS_AUTH_ENDPOINTS;
  payload: MarketplaceUserBodyType | MarketplaceSchoolBodyType | SsoFetchPayload;
}
